import * as t from "./types";
import * as actions from "./action";

/* YardSight-specific Actions */
export const ymsDeckingOptimizationTesterAction = (
  payload: t.YmsDeckingOptimizationTesterRequestType
): t.YmsDeckingOptimizationTesterActionType => {
  return {
    type: actions.YMS_DECKING_OPTIMIZATION_TESTER,
    payload,
  };
};

export const ymsDeckingFilterAction = (
  payload: t.YmsDeckingFilterRequestType
): t.YmsDeckingFilterActionType => {
  return {
    type: actions.YMS_DECKING_FILTER,
    payload,
  };
};
